import { NgModule } from '@angular/core';
import { MobauthComponent } from './mobauth.component';
import { HttpClientModule } from '@angular/common/http';



@NgModule({
  declarations: [MobauthComponent],
  imports: [
    HttpClientModule
  ],
  providers: [
  ],
  exports: [MobauthComponent]
})
export class MobauthModule { }
